import React from "react";
import { useHistory } from "react-router-dom";
import localeText from "../../../../locale";
import { useThemeContext } from "../../../../contexts/ThemeContext/ThemeContext";
import { resolveThemeImageUrl } from "../../../../utilities/resolveThemeImageUrl";
import Notifications from "../shared/Notifications/Notifications";
import defaultLogo from "../../../../pages/images/logo-color-horizontal.png";
import "./ManagerMobileNavbar.css";

const ManagerMobileNavbar = ({ onMenuButtonClick }) => {
  const history = useHistory();
  const { logoUrl, logoSmallUrl } = useThemeContext();
  // No celular, a logo própria do celular quando o white label tem uma
  const mobileLogo = logoSmallUrl || logoUrl;
  const logo = mobileLogo ? resolveThemeImageUrl(mobileLogo) || mobileLogo : defaultLogo;
  const isDefaultLogo = logo === defaultLogo;

  const handleLogoClick = () => {
    const isMobile = JSON.parse(localStorage.getItem("__extraconomy_ismobile__") || "false");
    history.push(isMobile ? "/shop" : "/");
  };

  return (
    <header className="manager-mobile-navbar">
      <button
        type="button"
        className={`manager-mobile-navbar__logo${
          isDefaultLogo ? " manager-mobile-navbar__logo_default" : ""
        }`}
        onClick={handleLogoClick}
        aria-label="extraconomy"
      >
        <img src={logo} alt="extraconomy" />
      </button>

      <div className="manager-mobile-navbar__actions">
        <div className="manager-mobile-navbar__notifications">
          <Notifications />
        </div>
        <div className="manager-mobile-navbar__separator" />
        <button
          type="button"
          className="manager-mobile-navbar__menu-btn"
          onClick={(e) => {
            onMenuButtonClick?.(e);
          }}
          aria-label={localeText("managerMobileNavOpenMenu")}
        >
          <i className="pi pi-bars" />
        </button>
      </div>
    </header>
  );
};

export default ManagerMobileNavbar;
